export const textLengthLimiter = (text: string, limit: number) => {
  if (text.length > limit) {
    return `${text.substring(0, limit + 1)}...`;
  } else {
    return text;
  }
};
